import { Channel } from 'bloggers-backend/lib/youtube/domain/SearchTask';

export type SocialNetwork = 'instagram' | 'facebook' | 'tikTok';

export const SOCIAL_NETWORKS: SocialNetwork[] = ['instagram', 'facebook', 'tikTok'];

export function getChannelSocialLinks(channel: Channel, network: SocialNetwork): string[] {
  if (channel.socialLinks) {
    return channel.socialLinks[network];
  }
  const legacyLink = channel[network];
  return legacyLink ? [legacyLink] : [];
}

export function hasBusinessEmail(channel: Channel): boolean {
  return channel.hasBusinessEmail === true;
}

export function hasAnySocialLink(channel: Channel): boolean {
  return SOCIAL_NETWORKS.some((network) => getChannelSocialLinks(channel, network).length > 0);
}

export function getSocialNetworkCount(channel: Channel): number {
  return SOCIAL_NETWORKS.filter((network) => getChannelSocialLinks(channel, network).length > 0).length;
}

export function getContactsScore(channel: Channel): number {
  const emailScore = hasBusinessEmail(channel) ? 1000 : 0;
  return emailScore + getSocialNetworkCount(channel);
}

export function wasPostedWithinDays(channel: Channel, days: number, now: Date): boolean {
  if (!channel.videoDate) {
    return false;
  }
  const elapsedDays = (now.getTime() - new Date(channel.videoDate).getTime()) / (24 * 60 * 60 * 1000);
  return elapsedDays <= days;
}

export function hasViewsAbove(channel: Channel, threshold: number): boolean {
  return channel.viewCount > threshold;
}

export interface ChannelFilterValues {
  hasEmail: boolean;
  hasSocial: boolean;
  postedWithinDays: number | null;
  viewsAboveThreshold: number | null;
}

export const EMPTY_CHANNEL_FILTERS: ChannelFilterValues = {
  hasEmail: false,
  hasSocial: false,
  postedWithinDays: null,
  viewsAboveThreshold: null,
};

export function channelMatchesFilters(channel: Channel, filters: ChannelFilterValues, now: Date): boolean {
  if (filters.hasEmail && !hasBusinessEmail(channel)) {
    return false;
  }
  if (filters.hasSocial && !hasAnySocialLink(channel)) {
    return false;
  }
  if (filters.postedWithinDays !== null && !wasPostedWithinDays(channel, filters.postedWithinDays, now)) {
    return false;
  }
  if (filters.viewsAboveThreshold !== null && !hasViewsAbove(channel, filters.viewsAboveThreshold)) {
    return false;
  }
  return true;
}
